<template>
  <AdModal :isVisible="true" :data="advertisement" v-if="advertisement" />
</template>

<script>
import { onMounted, onUpdated, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import AdModal from "@/components/Modals/Ad";

export default {
  components: { AdModal },
  setup() {
    const store = useStore();
    const route = useRoute();
    
    onMounted(() => {
        getAd()
    })

    onUpdated(() => {
        getAd()
    })

    const advertisement = computed(() => {
      return store.state.currentAd;
    });

    const getAd = () => {
      store.dispatch("GET_AD_BY_ID", route.params.id);
    };

    return { advertisement, getAd };
  },
};
</script>

<style></style>
